import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Disable browser scroll restoration globally so the app controls scroll on
// every navigation (ScrollToTop in App.js) and user-initiated in-page scrolls
// cannot be overridden by the browser.
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);